import { createRouter, createMemoryHistory } from 'vue-router'
import Home from '../views/step-home.vue'

const routes = [
  {
    path: '/test',
    name: 'Homeold',
    component: Home
  },

  {
    path: '/',
    name: 'one',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-one.vue')
  },
  {
    path: '/two',
    name: 'Two',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-two.vue')
  },
  {
    path: '/three',
    name: 'Three',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-three.vue')
  },
  {
    path: '/four',
    name: 'Four',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-four.vue')
  },
  {
    path: '/five',
    name: 'Five',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-five.vue')
  }
  ,
  {
    path: '/six',
    name: 'Six',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-six.vue')
  },
  {
    path: '/seven',
    name: 'Seven',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-seven.vue')
  },
  {
    path: '/eight',
    name: 'Eight',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-eight.vue')
  },
  {
    path: '/nine',
    name: 'Nine',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-nine.vue')
  },
  {
    path: '/ten',
    name: 'Ten',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/step-ten.vue')
  },
]

const router = createRouter({
  history: createMemoryHistory(),
    scrollBehavior() {
        // always scroll 10px above the element #main
        return {
            // could also be
            // el: document.getElementById('main'),
            el: '#app',
            top: 0,
        }
    },
  routes
})

export default router
